import { render, staticRenderFns } from "./AdminComplaintStatus.vue?vue&type=template&id=378ef3b2&scoped=true&"
import script from "./AdminComplaintStatus.vue?vue&type=script&lang=js&"
export * from "./AdminComplaintStatus.vue?vue&type=script&lang=js&"
import style0 from "./AdminComplaintStatus.vue?vue&type=style&index=0&id=378ef3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ef3b2",
  null
  
)

export default component.exports